<template>
  <v-dialog v-model="show" max-width="600px">
    <v-card>
      <v-card-title style="justify-content: center">{{ $t('subOrder.confirmationDelivered') }}</v-card-title>
      <v-card-text class="pb-0 text-center">{{ $t('subOrder.confirmShippingLabelGenerated') }}</v-card-text>
      <v-card-actions class="pa-0 mt-4">
        <v-btn color="primary" tile @click="validate()" style="width: 50%">{{ $t('subOrder.confirm') }}</v-btn>
        <v-btn color="secondary" tile class="ml-0" style="width: 50%" @click="close()">
          {{ $t('subOrder.close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: 'ConfirmationCarrierPickup',
    props: {
      value: {
        required: true,
      },
    },
    computed: {
      show: {
        get() {
          return this.value
        },
        set(value) {
          this.$emit('input', value)
        },
      },
    },
    methods: {
      validate() {
        this.$emit('confirm')
      },
      close() {
        this.$emit('close')
      },
    },
  }
</script>
